<app-login-layout class="reset-password">
	<h1>Reset password</h1>
	<ng-container *ngIf="token">
		<form [formGroup]="resetPasswordForm" (ngSubmit)="onResetPassword()">
			<app-input-field label="New Password" autocomplete="new-password" type="password"
				[control]="resetPasswordForm.get('password')" name="password" icon="lock">
			</app-input-field>
			<app-input-field label="Confirm New Password" autocomplete="new-password" type="password"
				[control]="resetPasswordForm.get('confirmPassword')" name="confirmPassword" icon="lock">
			</app-input-field>
			<div *ngIf="resetPasswordForm.errors && resetPasswordForm.errors.invalidToken" class="error-message">
				Reset password link is expired, request new link.
			</div>
			<div *ngIf="isPasswordMismatch" class="error-message">Password confirmation doesn't match Password.</div>
			<div class="form-actions">
				<a routerLink="/login">Log in</a>
				<mat-spinner *ngIf="loading" diameter="20"></mat-spinner>
				<button type="submit" mat-flat-button color="primary" [disabled]="resetPasswordForm.invalid || loading">
					Update
				</button>
			</div>
		</form>
	</ng-container>
	<ng-container *ngIf="!token">
		<p>Enter your email address below and we'll send you a link to reset your password.</p>
		<form [formGroup]="forgotPasswordForm" (ngSubmit)="onRequestPassword()">
			<app-input-field label="Email Address" placeholder="Enter your email address" type="email"
				[control]="forgotPasswordForm.get('email')" name="email" icon="email">
			</app-input-field>
			<div *ngIf="forgotPasswordForm.errors && forgotPasswordForm.errors.invalidEmail" class="error-message">
				Could not find any user with this email address.
			</div>
			<div class="form-actions">
				<a routerLink="/login">Log in</a>
				<mat-spinner *ngIf="loading" diameter="20"></mat-spinner>
				<button type="submit" mat-flat-button color="primary"
					[disabled]="forgotPasswordForm.invalid || loading">
					Submit
				</button>
			</div>
		</form>
	</ng-container>
</app-login-layout>